import PropTypes from 'prop-types';
import { useEffect, useState, useContext } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled, ThemeProvider } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
import Theme from '../../components/Button';  
// mock
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import Iconify from '../../components/Iconify';

import Telefone from '../../images/telefone.png';
import Loja from '../../images/loja.png';

// context
import { AuthContext } from '../../contexts/auth';
import {visualizarUsuario} from '../../services/api';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;
  const [navConfig, setNavConfig] = useState([]);
  const { logout } = useContext(AuthContext);
  
  let tipoComercio;
  let menuRestrito;
  let menu;

  const getTipoComercio = async () => {

    const validaTipoComercio = localStorage.getItem(['tipo_comercio']);
    const validaMenuRestrito = localStorage.getItem(['menu_restrito']);

    if (validaTipoComercio === null) {
        const response = await visualizarUsuario(account.displayName);
        
        if(response.erro === true) {
          if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
            logout();
          }
        }else{
          tipoComercio = response.data[0].empresa.tipo_comercio;
          menuRestrito  = response.data[0].menu_restrito;
          localStorage.setItem("tipo_comercio", response.data[0].empresa.tipo_comercio);
          localStorage.setItem("menu_restrito", response.data[0].menu_restrito);
        };    
    } else {
       tipoComercio = parseInt(validaTipoComercio, 10);
       menuRestrito = parseInt(validaMenuRestrito, 10);
    };

    if (tipoComercio === 999) {
      menu = [{
                title: 'Indicadores',
                path: '/indicadores/app',
                icon: getIcon('eva:pie-chart-2-fill'),
              },
              {
                title: 'Usuários',
                path: '/usuarios/consultar',
                icon: getIcon('bi:person-fill'),
              },
              {
                title: 'Empresas',
                path: '/empresas/consultar',
                icon: getIcon('fa-solid:store-alt'),
              }];
    }else if (tipoComercio === 1){
      if (menuRestrito === 1) {
        menu = [{
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Serviços',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },
        ];
      }else{
        menu = [{
          title: 'Indicadores',
          path: '/indicadores/app',
          icon: getIcon('eva:pie-chart-2-fill'),
        },
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Produtos/Serviços',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },
        {
          title: 'Fornecedores',
          path: '/fornecedor/consultar',
          icon: getIcon('eva:car-fill'),
        },
        {
          title: 'Despesas',
          icon: getIcon('bx:money-withdraw'),
          children: [{title: 'Tipo Despesas',
                      path: '/tipo_despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     },
                     {title: 'Consulta Despesas',
                      path: '/despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     }]
        }];
      }  
    }else if (tipoComercio === 2){
      if (menuRestrito === 1) { 
        menu = [
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Vendas Mesa',
          path: '/venda_comercio/venda_por_mesa',
          icon: getIcon('material-symbols:table-restaurant'),
        }];
      }else{
        menu = [{
          title: 'Indicadores',
          path: '/indicadores/app',
          icon: getIcon('eva:pie-chart-2-fill'),
        },
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Vendas Mesa',
          path: '/venda_comercio/venda_por_mesa',
          icon: getIcon('material-symbols:table-restaurant'),
        },
        {
          title: 'Produtos/Serviços',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },
        {
          title: 'Fornecedores',
          path: '/fornecedor/consultar',
          icon: getIcon('eva:car-fill'),
        },
        {
          title: 'Despesas',
          icon: getIcon('bx:money-withdraw'),
          children: [{title: 'Tipo Despesas',
                      path: '/tipo_despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     },
                     {title: 'Consulta Despesas',
                      path: '/despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     }]
        },
        {
          title: 'Mesas',
          path: '/mesa/consultar',
          icon: getIcon('material-symbols:table-restaurant'),
        }];
      }
    }else if (tipoComercio === 3 || tipoComercio === 6){
      if (menuRestrito === 1) { 
        menu = [
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },  
        {
          title: 'Produtos',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        }];
      }else{
        menu = [{
                  title: 'Indicadores',
                  path: '/indicadores/app',
                  icon: getIcon('eva:pie-chart-2-fill'),
                },
                {
                  title: 'Vendas',
                  path: '/venda/consultar',
                  icon: getIcon('eva:shopping-bag-fill'),
                },
                {
                  title: 'Produtos/Serviços',
                  path: '/produto/consultar',
                  icon: getIcon('fluent:box-16-filled'),
                },
                {
                  title: 'Clientes',
                  path: '/cliente/consultar',
                  icon: getIcon('eva:people-fill'),
                },
                {
                  title: 'Fornecedores',
                  path: '/fornecedor/consultar',
                  icon: getIcon('eva:car-fill'),
                },
                {
                  title: 'Despesas',
                  icon: getIcon('bx:money-withdraw'),
                  children: [{title: 'Tipo Despesas',
                              path: '/tipo_despesa/consultar',
                              icon: getIcon('bx:money-withdraw')
                            },
                            {title: 'Consulta Despesas',
                              path: '/despesa/consultar',
                              icon: getIcon('bx:money-withdraw')
                            }]
                }];
      }        
    }else if (tipoComercio === 4){
      if (menuRestrito === 1) { 
        menu = [
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        }]; 
      }else{
        menu = [{
          title: 'Indicadores',
          path: '/indicadores/app',
          icon: getIcon('eva:pie-chart-2-fill'),
        },
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('eva:shopping-bag-fill'),
        },
        {
          title: 'Serviços',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },
        {
          title: 'Fornecedores',
          path: '/fornecedor/consultar',
          icon: getIcon('eva:car-fill'),
        },
        {
          title: 'Despesas',
          icon: getIcon('bx:money-withdraw'),
          children: [{title: 'Tipo Despesas',
                      path: '/tipo_despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     },
                     {title: 'Consulta Despesas',
                      path: '/despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                     }]
        }
      ];
      }
      
    }else if (tipoComercio === 5){
      if (menuRestrito === 1) { 
        menu = [{
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('mdi:airplane'),
        },
        {
          title: 'Produtos',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        }];
      }else{
        menu = [{
          title: 'Indicadores',
          path: '/indicadores/app',
          icon: getIcon('eva:pie-chart-2-fill'),
        },
        {
          title: 'Vendas',
          path: '/venda/consultar',
          icon: getIcon('mdi:airplane'),
        },
        {
          title: 'Produtos',
          path: '/produto/consultar',
          icon: getIcon('fluent:box-16-filled'),
        },
        {
          title: 'Clientes',
          path: '/cliente/consultar',
          icon: getIcon('eva:people-fill'),
        },
        {
          title: 'Fornecedores',
          path: '/fornecedor/consultar',
          icon: getIcon('mdi:account-switch'),
        },
        {
          title: 'Despesas',
          icon: getIcon('bx:money-withdraw'),
          children: [{title: 'Tipo Despesas',
                      path: '/tipo_despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                    },
                    {title: 'Consulta Despesas',
                      path: '/despesa/consultar',
                      icon: getIcon('bx:money-withdraw')
                    }]
        }];
      } 
    }else {
      menu = [{
                title: 'Indicadores',
                path: '/indicadores/app',
                icon: getIcon('eva:pie-chart-2-fill'),
              },
              {
                title: 'Vendas',
                path: '/venda/consultar',
                icon: getIcon('eva:shopping-bag-fill'),
              },
              {
                title: 'Produtos/Serviços',
                path: '/produto/consultar',
                icon: getIcon('fluent:box-16-filled'),
              },
              {
                title: 'Clientes',
                path: '/cliente/consultar',
                icon: getIcon('eva:people-fill'),
              },
              {
                title: 'Fornecedores',
                path: '/fornecedor/consultar',
                icon: getIcon('eva:car-fill'),
              },
              {
                title: 'Despesas',
                icon: getIcon('bx:money-withdraw'),
                children: [{title: 'Tipo Despesas',
                            path: '/tipo_despesa/consultar',
                            icon: getIcon('bx:money-withdraw')
                           },
                           {title: 'Consulta Despesas',
                            path: '/despesa/consultar',
                            icon: getIcon('bx:money-withdraw')
                           }]
              }];
      
    }
    setNavConfig(menu);
  }

  

  useEffect(() => {
    getTipoComercio();
    
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 10, py: 3, display: 'flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar src={Loja} alt="photoURL" />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {account.descricaoEmpres}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.descricaoEmpresa}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      <NavSection navConfig={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
      
      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
          <Box
            component="img"
            src={Telefone}
            sx={{ width: 60, position: 'absolute', top: -12 }}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Dúvidas?
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Ligue para (62)4101-2544 ou via Whatsapp no botão abaixo.
            </Typography>
          </Box>

          <ThemeProvider theme={Theme}>
            <Button color="neutral" href="https://api.whatsapp.com/send?phone=556241012544" target="_blank" variant="contained" startIcon={<Iconify icon="mdi:whatsapp" />}>
              Whatsapp
            </Button>
          </ThemeProvider>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Versão: 2.5
          </Typography>
        </Stack>
      </Box>

    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
